// extracted by mini-css-extract-plugin
module.exports = {"arrow":"SelectArrow_arrow__ZMnj5","icon":"SelectArrow_icon__6T4RY","disabled":"SelectArrow_disabled__gtH5n","open":"SelectArrow_open__dPlis"};